<!-- 经营时间 -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="base-content">
            <el-form :model="formData" ref="formData" label-width="250px" v-if="formData.PushType == 0">
                <el-form-item label="推送方向">
                    <div class="push-zone">
                        <el-input size="small" style="width: 220px" :title="formData.EntpName" v-model="formData.EntpName" :disabled="true"></el-input>
                        <div class="dir-icon">将订单推送给</div>
                        <el-input size="small" style="width: 220px" :title="formData.PushEntpName" v-model="formData.PushEntpName" :disabled="true"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="推送仓库">
                    <div class="sto-zone">
                        <el-checkbox-group v-model="checkStos" @change="handleCheckedChange">
                            <el-checkbox v-for="item in warehouseList" :checked="item.IsSelect" :label="item.WarehouseId" :key="item.WarehouseId">{{
                                item.WarehouseName
                            }}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </el-form-item>
                <el-form-item label="是否创建采购单" prop="IsCreatPurO">
                    <el-switch v-model="formData.IsCreatPurO" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                </el-form-item>
                <el-form-item label="采购供应商" prop="SupId">
                    <el-select
                        style="width: 220px"
                        size="small"
                        v-model="formData.SupId"
                        filterable
                        clearable
                        remote
                        reserve-keyword
                        :remote-method="searchSupplier"
                        v-select-scroll-more="searchSupplierLoad"
                        @visible-change="supplierVisibleChange($event)"
                        placeholder="选择供应商"
                    >
                        <el-option
                            v-for="(optionItem, index) in supList"
                            :key="index"
                            :data-msg="optionItem"
                            :label="optionItem.EntpCusName"
                            :value="optionItem.EntpCusId"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="默认结算方式" prop="PayType">
                    <el-select v-model="formData.PayType" clearable placeholder="请选择" style="width: 220px" size="small">
                        <el-option v-for="(item, index) in payWayList" :key="index" :label="item.Text" :value="item.Value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否推送" prop="IsPush">
                    <el-switch v-model="formData.IsPush" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                </el-form-item>
                <el-form-item>
                    <el-button :disabled="!formData.SetId" class="btn-primary" @click="submitForm">提交保存</el-button>
                </el-form-item>
            </el-form>
            <el-form :model="formData" ref="formData" label-width="250px" v-else>
                <el-form-item label="推送方向">
                    <div class="push-zone">
                        <el-input size="small" style="width: 220px" :title="formData.EntpName" v-model="formData.EntpName" :disabled="true"></el-input>
                        <div class="dir-icon">将订单推送给</div>
                        <el-input size="small" style="width: 220px" :title="formData.PushEntpName" v-model="formData.PushEntpName" :disabled="true"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="销售客户" prop="PushCusId">
                    <el-select
                        style="width: 220px"
                        size="small"
                        v-model="formData.PushCusId"
                        filterable
                        clearable
                        remote
                        reserve-keyword
                        :remote-method="searchCustomer"
                        v-select-scroll-more="searchCustomLoad"
                        @visible-change="customerVisibleChange($event)"
                        placeholder="输入客户名称/电话"
                    >
                        <el-option
                            v-for="optionItem in customerList"
                            :key="optionItem.EntpCusId"
                            :data-msg="optionItem"
                            :label="optionItem.EntpCusName"
                            :value="optionItem.EntpCusId"
                        >
                            <span style="float: left">{{ optionItem.EntpCusName }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">{{ optionItem.CallNum }}</span>
                        </el-option>
                        <el-option v-if="loading" disabled value style="text-align: center"> 加载中 <i class="el-icon-loading"></i> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="销售员" prop="PushStaffId">
                    <el-select v-model="formData.PushStaffId" placeholder="请选择">
                        <el-option v-for="item in staffList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="默认提交订单" prop="IsSubmitSaleO">
                    <el-switch v-model="formData.IsSubmitSaleO" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                </el-form-item>
                <el-form-item label="默认出仓仓库" prop="PushStoId">
                    <el-select
                        v-model="formData.PushStoId"
                        placeholder="请选择"
                        style="width: 220px"
                        size="small"
                        filterable
                        clearable
                        @visible-change="warehouseVisibleChange($event)"
                    >
                        <el-option v-for="optionItem in warehouseList" :key="optionItem.WarehouseId" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId">
                            <span style="float: left">{{ optionItem.WarehouseName }}</span>
                            <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button :disabled="!formData.SetId" class="btn-primary" @click="submitForm">提交保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: '',
    components: {
        breadcrumb
    },
    data() {
        return {
            loading: false,
            formData: {
                SetId: '',
                PushType: 0,
                IsCreatPurO: false,
                IsPush: false,
                SupId: '',
                PushStaffId: '',
                PushCusId: '',
                EntpName: '',
                PushEntpName: '',
                SupName: '',
                PushStaffName: '',
                PushCusName: '',
                IsSubmitSaleO: false,
                PushStoId: '',
                StoIds: [],
                PayType: ''
            },
            staffList: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            customerList: [],
            supList: [],
            supplierForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            warehouseList: [],
            checkStos: [],
            payWayList: []
        };
    },
    mounted() {
        this.getStaffList();
        this.getData();
    },
    methods: {
        // 获取数据
        getData() {
            let that = this;
            that.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetEntpPushSets'
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        that.$util.warningMsg(res.errmsg);
                        return;
                    }

                    that.formData = data;

                    if (data.PushType == 0) {
                        that.supList.push({
                            EntpCusId: data.SupId,
                            EntpCusName: data.SupName
                        });

                        that.getWarehouse();
                        that.getPay();
                    } else {
                        that.customerList.push({
                            EntpCusId: data.PushCusId,
                            EntpCusName: data.PushCusName,
                            CallNum: data.pushCusPhone
                        });

                        let w = that.warehouseList.find(e => e.WarehouseId == data.PushStoId);
                        if (!w) {
                            that.warehouseList = [
                                {
                                    WarehouseId: data.PushStoId,
                                    WarehouseName: data.WarehouseName,
                                    Type: data.Type
                                }
                            ];
                        }
                    }

                    let i = that.staffList.findIndex(item => {
                        if (item.EmployeeId == data.PushStaffId) {
                            return true;
                        }
                    });
                    if (i == -1) {
                        that.staffList.push({
                            EmployeeId: data.PushStaffId,
                            EmployeeName: data.PushStaffName
                        });
                    }
                })
                .catch(() => {});
        },
        getStaffList() {
            this.$util.getCommonSIdList().then(data => {
                this.staffList = data;
            });
        },
        // 提交数据
        submitForm() {
            let that = this;
            if (that.formData.PushType == 0) {
                if (!that.formData.SupId && that.formData.IsCreatPurO) {
                    that.$util.warningMsg('请选择采购供应商');
                    return;
                }

                that.formData.StoIds = that.checkStos;
                if (!that.formData.StoIds || that.formData.StoIds.length <= 0) {
                    that.$util.warningMsg('请选择要推送的仓库');
                    return;
                }
            } else {
                if (!that.formData.PushCusId) {
                    that.$util.warningMsg('请选择销售单对应的客户');
                    return;
                }

                if (that.formData.IsSubmitSaleO && !that.formData.PushStoId) {
                    that.$util.warningMsg('默认提交需要选择默认出仓仓库');
                    return;
                }
            }

            that.$util
                .axiosPost({
                    url: '/api/EntpInfoManagement/SaveEntpPusSets',
                    data: this.formData
                })
                .then(res => {
                    that.$util.successMsg('设置成功');
                })
                .catch(() => {});
        },

        // 搜索顾客
        searchCustomer(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.customerList = [];
            }
            if (this.cusForm.stopLoad) return;
            this.loading = true;
            this.$util
                .searchCustomer(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit)
                .then(data => {
                    this.cusForm.stopLoad = data && data.length < this.cusForm.Limit;
                    if (data) this.customerList = [...this.customerList, ...data];
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustomer();
        },
        //当客户下拉框出现时触发
        customerVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.customerList.length <= 1) that.searchCustomer('');
            }
        },
        searchSupplierLoad() {
            this.supplierForm.Page += 1;
            this.searchSupplier();
        },
        searchSupplier(key) {
            if (![undefined].includes(key)) {
                this.supplierForm.Page = 1;
                this.supplierForm.stopLoad = false;
                this.supplierForm.key = key;
                this.supList = [];
            }
            if (this.supplierForm.stopLoad) return;
            this.loading = true;
            this.$util.searchSupplier(this.supplierForm.key, this.supplierForm.Page, this.supplierForm.Limit).then(data => {
                this.loading = false;
                if (!data) return;
                this.supplierForm.stopLoad = data.length < this.supplierForm.Limit;
                this.supList = this.$util.uniqueArr(this.supList, data);
            });
        },
        supplierVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.supList.length <= 1) that.searchSupplier('');
            }
        },
        getWarehouse() {
            this.$util.getWarehouse(1).then(data => {
                this.warehouseList = data;

                if (this.formData.PushType == 0) this.checkStos = this.formData.StoIds;
            });
        },
        warehouseVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length <= 1) that.getWarehouse();
            }
        },
        handleCheckedChange(value) {
            this.checkStos = value;
        },
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
            });
        }
    }
};
</script>
<style lang="less" scoped>
.push-zone {
    display: flex;
    flex-direction: row;
}
.dir-icon {
    display: flex;
    flex-direction: row;
    width: 100px;
    justify-content: center;
    align-items: center;
}

.base-content {
    max-width: 1200px;
    margin: 0 auto;
    margin-top: 50px;
}
.open-time-item {
    display: flex;
    align-items: center;
    span {
        margin-right: 20px;
    }
    i {
        font-size: 18px;
        cursor: pointer;
    }
}
.add-open-time {
    margin-bottom: 10px;
    i {
        font-size: 18px;
        cursor: pointer;
        margin-left: 20px;
    }
}
</style>
